"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGitHubRepository = void 0;
const organization_1 = require("./organization");
const user_1 = require("./user");
function fromGitHubRepository(repo) {
    if (!repo)
        return null;
    return {
        id: repo.id || '',
        name: repo.name || '',
        fullName: repo.full_name || '',
        isFork: repo.fork === true,
        isPrivate: repo.private === true,
        owner: repo.owner && repo.owner.type === 'Organization'
            ? organization_1.fromGitHubOrg(repo.owner)
            : user_1.fromGitHubUser(repo.owner),
    };
}
exports.fromGitHubRepository = fromGitHubRepository;
//# sourceMappingURL=repository.js.map